module.exports = __webpack_public_path__ + "img/title4.40408051.png";